import { Component, input, InputSignal } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { BaseFormField } from '../../shared/base-form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-terms-check-field',
  standalone: true,
  imports: [
    TranslateModule,
    MatFormFieldModule,
    MatCheckboxModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: TermsCheckFieldComponent
    },
  ],
  templateUrl: './terms-check-field.component.html',
  styleUrls: ['./terms-check-field.component.scss'],
})
export class TermsCheckFieldComponent extends BaseFormField {
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  public formControlName: InputSignal<string> = input.required<string>();

  public onCheckboxChange(event: MatCheckboxChange): void {
    this.form().get(this.formControlName())?.setValue(event.checked);
  }
}
